import React from "react";
import { useSelector } from "react-redux";
import { fetchCartitemslice } from "../../features/cartItemSlice";
import { removeFromCart } from "../../features/cartSlice";
import axios from "axios";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";
import { api } from "../Constants";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
function Cart() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const dispatch = useDispatch();

  var subject = "testing";

  const userid = localStorage.getItem("userid");

  const navigate = useNavigate();

  const handleShow = () => {
    setShow(true);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleChange3 = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleChange4 = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    city: "",
    message: "",
  });

  const { cartItems = [] } = useSelector((state) => state.cartListslice);

  const [cartItemsss, setCartItems] = useState(cartItems);

  const cartItemIds = cartItems.map((item) => item.id);

  useEffect(() => {
    setCartItems(cartItems.map((item) => ({ ...item })));
  }, [cartItems]);

  useEffect(() => {
    if (userid) {
      dispatch(fetchCartitemslice({ userids: userid }));
    }
  }, [dispatch, userid]);

  const Removecart = (product_id) => {
    dispatch(removeFromCart({ product_id, userid }));
    dispatch(fetchCartitemslice({ userids: userid }));
  };

  const handleClick = async () => {
    if (
      !formData.name == "" &&
      !formData.mobile == "" &&
      !formData.email == "" &&
      !formData.city == "" &&
      !formData.message == ""
    ) {
      try {
        const response = await axios.post(api + "dealer_enquiry_add", {
          dealer_id: userid,
          subject: subject,
          city: formData.city,
          message: formData.message,
          products: cartItemIds,
        });

        if (response.status === 200) {
          toast.success("Enquiry Submitted Successfully");
          navigate("/enquiry-success");
          handleClose();
          dispatch(fetchCartitemslice({ userids: userid }));
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getProfile = async () => {
    await axios
      .post(api + "get_profile", {
        dealer_id: userid,
      })
      .then((res) => {
        if (res.data.data.name) {
          setFormData((prev) => ({
            ...prev,
            name: res.data.data.name,
          }));
        }

        if (res.data.data.mobile) {
          setFormData((prev) => ({
            ...prev,
            mobile: res.data.data.mobile,
          }));
        }

        if (res.data.data.email) {
          setFormData((prev) => ({
            ...prev,
            email: res.data.data.email,
          }));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (userid) {
      getProfile();
    }
  }, [userid]);

  const [pair, setPair] = useState("");

  const [showcart, setShowcart] = useState(false);

  const [cartFormData, setCartFormData] = useState("");

  const [editcartId, setEditcartid] = useState("");

  const handleShowcart = async (item) => {
    try {
      const response = await axios.post(api + "edit_cart", {
        cart_id: item.cart_id,
        quantity_variant: item.quantity_variant,
      });
      setEditcartid(item.cart_id);
      setCartFormData(response.data.data);
      setShowcart(true);
      setPair(response.data.data.variant);
    } catch (err) {
      console.log(err);
    }
  };

  const handleupdate = async (e) => {
    e.preventDefault();

    try {
      await axios
        .post(api + "update_cart", {
          cart_id: editcartId,
          qty: cartFormData.qty,
          size: cartFormData.size,
          carat: cartFormData.carat,
          weight: cartFormData.weight,
          remarks: cartFormData.remarks,
        })
        .then((res) => {
          setShowcart(false);
          dispatch(fetchCartitemslice({ userids: userid }));
          toast.success(res.data.message);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const handleClosecart = () => {
    setShowcart(false);
    setEditcartid("");
  };

  const [popupImage, setPopupImage] = useState(null);

  return (
    <section className="cart_section pt-5 pb-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="inner-box table-responsive">
              {cartItemsss && cartItemsss.length > 0 ? (
                <>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                         <th>Image</th>
                        <th>SKU</th>
                          <th>Category</th>
                        <th>Carat</th>
                        <th>Quantity</th>
                        <th>Size</th>
                       
                        <th>Weight</th>
                        <th>Remarks </th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItemsss.length > 0 ? (
                        <>
                          {cartItemsss.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>

                                  <td>
                                  <img
                                    src={item.product_image}
                                    style={{
                                      width: "60px",
                                      height: "60px",
                                      objectFit: "cover",
                                      cursor: "pointer",
                                    }}
                                    alt=""
                                    onClick={() =>
                                      setPopupImage(item.product_image)
                                    }
                                  />
                                </td>

                                <td>
                                  <Link
                                    to={`/product-details/${item.slug_name}`}
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                  >
                                    {item.product_code}{" "}
                                  </Link>
                                </td>
                                 <td>{item.category_name}</td>
                                <td>{item.carat}</td>
                              
                                <td>
                                  <div className="quantity-control">
                                    <div className="">{item.quantity} {item.quantity_variant}</div>
                                  </div>
                                </td>
                                <td>{item.sizes} /16</td>
                                
                                <td>{item.weight} gms</td>
                                <td>{item.remarks}</td>
                                <td>
                                  <div className="d-flex justify-content-center gap-2">
                                    <button
                                      className="remove_cart btn btn-primary"
                                      style={{ padding: "10px" }}
                                      onClick={() => handleShowcart(item)}
                                    >
                                      Edit
                                    </button>
                                    <button
                                      onClick={() => Removecart(item.id)}
                                      className="remove_cart btn btn-primary"
                                      style={{ padding: "10px" }}
                                    >
                                      x
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : null}
                    </tbody>
                  </table>
                  {popupImage && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                      }}
                    >
                      <div
                        style={{
                          position: "relative",
                          background: "#fff",
                          padding: "10px",
                          borderRadius: "8px",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                        }}
                      >
                        <button
                          onClick={() => setPopupImage(null)}
                          style={{
                            position: "absolute",
                            top: "-10px",
                            right: "-10px",
                            background: "#bc1823",
                            color: "#fff",
                            border: "none",
                            borderRadius: "50%",
                            width: "30px",
                            height: "30px",
                            cursor: "pointer",
                          }}
                        >
                          ×
                        </button>
                        <img
                          src={popupImage}
                          alt="Full Preview"
                          style={{
                            maxWidth: "80vw",
                            maxHeight: "80vh",
                            borderRadius: "4px",
                          }}
                        />
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <p className="text-center pt-3 pb-3">
                  No Products found in Cart
                </p>
              )}
            </div>
            {cartItemsss.length > 0 ? (
              <>
                <div className="text-end">
                  <button
                    className="btn btn-cart"
                    style={{ border: "1px solid #bc1823" }}
                    onClick={() => {
                      handleShow();
                    }}
                  >
                    Enquiry now
                  </button>
                </div>
              </>
            ) : null}

            <Modal
              show={show}
              onHide={handleClose}
              className="modal fade entry-popup"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {" "}
                  <span>For Enquiry Enter Your Details</span>
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  style={{ border: "none" }}
                  onClick={() => {
                    setShow(false);
                  }}
                >
                  <span className="contactclosebutton" aria-hidden="true">
                    &times;
                  </span>
                </button>
              </div>
              <Modal.Body>
                <form method="POST" action="javascript:void(0)">
                  <div className="row mb3 g-3">
                    <div className="col-lg-12 col-md-12 mb20">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Your Name"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        onKeyPress={(event) => {
                          if (!/[a-z,A-Z]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        required
                      ></input>
                    </div>
                    <div className="col-lg-12 col-md-12 mb20">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Phone Number"
                        id="mobile"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange1}
                        maxLength="10"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        required
                      ></input>
                    </div>
                    <div className="col-lg-12 col-md-12 mb20">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email Address"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange2}
                        required
                      ></input>
                    </div>
                    <div className="col-lg-12 col-md-12 mb20">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Your City"
                        id="city"
                        name="city"
                        value={formData.city}
                        onChange={handleChange4}
                        required
                      ></input>
                    </div>

                    <div class="col-lg-12 col-sm-12 mb20">
                      <textarea
                        type="Message"
                        class="form-control"
                        placeholder="Message"
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange3}
                        required
                      ></textarea>
                      <small id="messageerror" class="error"></small>
                    </div>
                    <div>
                      {/* <div className="col-lg-12 col-md-12 mb20">
                            <ReCAPTCHA
                              sitekey={
                                "6LdGiY0oAAAAAH9EQi94D43RkIXkRWpc1x99AUTv"
                              }
                              Secret
                              Key={"6LdGiY0oAAAAALltd2vMsg0i0HeJ9J33rYDM7pnP"}
                              className="g-recaptcha my-3"
                              onChange={onChange}
                            />
                          </div> */}
                      <input
                        type="hidden"
                        id="product_code"
                        name="product_code"
                        value={formData.product_code}
                        readOnly
                      />
                      <input
                        type="hidden"
                        id="product_id"
                        name="product_id"
                        value={formData.product_id}
                        readOnly
                      />
                      <Modal.Footer className="validationpopup-button-sec">
                        <button
                          className="main-btn mr2"
                          download=""
                          onClick={handleClick}
                        >
                          Submit
                        </button>
                        <button
                          type="close"
                          className="main-btn ml2 closebtn"
                          data-dismiss="modal"
                          onClick={() => {
                            setShow(false);
                          }}
                        >
                          close
                        </button>
                      </Modal.Footer>
                    </div>
                  </div>
                </form>
              </Modal.Body>
            </Modal>

            <Modal show={showcart} onHide={handleClosecart} centered>
              <Modal.Header closeButton>
                <Modal.Title>Edit Cart</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <form method="POST" onSubmit={handleupdate}>
                  <div className="row g-3">
                    <div className="col-12 mb20">
                      <div className="input_inner_box">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Quantity"
                          name="qty"
                          value={cartFormData.qty}
                          onChange={(e) =>
                            setCartFormData({
                              ...cartFormData,
                              qty: e.target.value,
                            })
                          }
                          required
                        />
                        <span className="input_sub_inner_box">{pair}</span>
                      </div>
                    </div>

                    {/* Sizes */}
                    <div className="col-12 mb20">
                      <div className="input_inner_box">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Sizes"
                          name="size"
                          value={cartFormData.size}
                          onChange={(e) =>
                            setCartFormData({
                              ...cartFormData,
                              size: e.target.value,
                            })
                          }
                          required
                        />
                        <span className="input_sub_inner_box">/ 16</span>
                      </div>
                    </div>

                    {/* Carat */}
                    <div className="col-12 mb20">
                      <div className="input_inner_box">
                        <select
                          className="form-control"
                          name="carat"
                          value={cartFormData.carat}
                          onChange={(e) =>
                            setCartFormData({
                              ...cartFormData,
                              carat: e.target.value,
                            })
                          }
                          required
                        >
                          <option value="" disabled>
                            Select Carat
                          </option>
                          <option value="22 KT">22 KT</option>
                          <option value="18 KT Yellow Gold">
                            18 KT Yellow Gold
                          </option>
                          <option value="18KT Rose Gold">18KT Rose Gold</option>
                          <option value="18KT White Gold">
                            18KT White Gold
                          </option>
                        </select>
                        <span className="input_sub_inner_box">CT</span>
                      </div>
                    </div>

                    {/* Weight */}
                    <div className="col-12 mb20">
                      <div className="input_inner_box">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Weight"
                          name="weight"
                          value={cartFormData.weight}
                          onChange={(e) =>
                            setCartFormData({
                              ...cartFormData,
                              weight: e.target.value,
                            })
                          }
                          required
                        />
                        <span className="input_sub_inner_box">gms</span>
                      </div>
                    </div>
                    <div className="col-12 mb20">
                      <textarea
                        rows={5}
                        className="form-control"
                        placeholder="Remarks"
                        name="remarks"
                        value={cartFormData.remarks}
                        onChange={(e) =>
                          setCartFormData({
                            ...cartFormData,
                            remarks: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                  </div>

                  <Modal.Footer>
                    <button type="submit" className="main-btn mr2">
                      Submit
                    </button>
                    <button
                      type="button"
                      className="main-btn ml2 closebtn"
                      onClick={handleClosecart}
                    >
                      Close
                    </button>
                  </Modal.Footer>
                </form>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Cart;
